import styled from "styled-components";
import DropdownOption from "../Components/DropdownOption.jsx";
import MemberRankingTable from "../Components/MemberRankingTable.jsx";
import PeriodOption from "../Components/PeriodOption.jsx";
import { ReactComponent as IconInfo } from "../Images/icon_info.svg";
import Pagination from "../Layout/Pagination.jsx";

const MemberRankingSection = ({
  rankingList,
  periodOptionChange,
  nationOptionChange,
  totalMember,
  page,
  setPage,
}) => {
  return (
    <div>
      <RankingNotice>
        <RankingNoticeContent>
          <IconInfo width="20px" height="20px" fill="#1167ed" />
          <RankingNoticeText>
            앱 내 홈화면에서 제공되는 실시간 랭킹입니다.
          </RankingNoticeText>
        </RankingNoticeContent>
      </RankingNotice>
      <RankingToolbar>
        <PeriodOption optionChange={periodOptionChange} />
        <RankingToolbarFilters>
          <DropdownOption
            title="전체 국가"
            dropdown_list={["한국", "중국", "미국", "일본", "인도", "싱가포르"]}
            optionChange={nationOptionChange}
          />
        </RankingToolbarFilters>
      </RankingToolbar>
      <RankingTables>
        <MemberRankingTable rankings={rankingList.slice(0, 10)} page="Members" />
        <RankingTableGap />
        <MemberRankingTable rankings={rankingList.slice(10, 20)} page="Members" />
      </RankingTables>
      <Pagination
        totalPages={totalMember === 0 ? 1 : Math.ceil(totalMember / 10)}
        currentPage={page}
        onPageChange={(pageNum) => setPage(pageNum)}
      />
    </div>
  );
};

const RankingNotice = styled.div.attrs({ className: "hrz-wrapper" })`
  margin-top: 20px;
  background-color: #dbe8fd;
  height: 44px;
  border-radius: 6px;
`;

const RankingNoticeContent = styled.div`
  margin-left: 20px;
  display: flex;
`;

const RankingNoticeText = styled.p`
  color: #1167ed;
  font-size: 15px;
  margin-left: 4px;
`;

const RankingToolbar = styled.div.attrs({ className: "hrz-wrapper" })`
  margin-top: 20px;
`;

const RankingToolbarFilters = styled.div`
  margin-left: auto;
`;

const RankingTables = styled.div`
  display: flex;
  margin-top: 10px;
`;

const RankingTableGap = styled.div`
  width: 20px;
`;

export default MemberRankingSection;
